import React from 'react';
import ResultsRow from 'components/layout/ResultsRow';
import { applyStyles } from 'utils/textUtils';
import { MessageSourceProps, withMessages } from 'react-message-source';

interface Props extends MessageSourceProps {
  numResults?: number,
  numSelected?: number,
  textMessage: string
}

const SearchResultComponent = (props: Props) => {

  const {numResults, numSelected, getMessage, textMessage} = props;

  if (numResults !== null && numSelected !== null) {
    return (
        <ResultsRow>
          <div className={"results-summary"}>
            {
              applyStyles(getMessage(`${textMessage}`)
                  .replace("{{numSelected}}", "" + numSelected)
                  .replace("{{numResults}}", "" + numResults)
              )
            }
          </div>
        </ResultsRow>
    )
  }

  return (
      <ResultsRow>
        <div className={"results-summary"}>
          {
            applyStyles(
                numSelected ?
                    getMessage(`${textMessage}`)
                        .replace("{{numSelected}}", "" + numSelected) :
                    numResults ?
                        getMessage(`${textMessage}`)
                            .replace("{{numResults}}", "" + numResults) :
                        ""
            )
          }
        </div>
      </ResultsRow>
  )
}

export default withMessages(SearchResultComponent);
